module.exports = __webpack_public_path__ + "static/media/R6.808c31ba.jpg";